export default {
  add_items: 'Artikel hinzufügen',
  remove_items: 'Artikel entfernen',
  place_order: 'Bestellung aufgeben',
  pay_now: 'Jetzt bezahlen · {{amount}}',
  go_to_menu: 'Zum Menü gehen',
  secure_checkout: 'Sichereres Bezahlen...',

  modals: {
    account_switch: {
      title: 'Das Konto mit der Telefonnummer {{phoneNumber}} existiert bereits',
      description:
        'Wir haben dich sorgfältig in das vorhandene Konto eingeloggt und dabei die Informationen, die du eingegeben hast, behalten 😊',
      button: 'Weiter',
    },
  },

  error_messages: {
    payment_unsuccessful: {
      title: 'Zahlung fehlgeschlagen',
      description: 'Bitte überprüfe deine Zahlungsinformationen und versuche es erneut.',
    },
    internal_error: {
      title: 'Bestellung erfolglos 😔',
      description:
        'Leider gab es ein unerwartetes Problem mit deiner Bestellung, unser technisches Team arbeitet bereits daran 🛠️.',
    },
    order_blocked: {
      title: 'Bestellung blockiert',
      description:
        'Wir haben verdächtige Aktivität von deinem Konto bemerkt und neue Bestellungen bis {{datetime}} blockiert. Kontaktiere unseren Support unter {{supportEmail}} für Details.',
      description_no_datetime:
        'Wir haben verdächtige Aktivität von deinem Konto bemerkt und neue Bestellungen blockiert. Kontaktiere unseren Support unter {{supportEmail}} für Details.',
    },
  },

  toasts: {
    input_errors_found: 'Es gibt einige Probleme mit den Bestelldaten',
    select_payment_method: 'Wähle eine Zahlungsmethode, um deine Bestellung aufzugeben.',
  },
};
